import http from "services/http";

export interface IAffiliateReferral {
  _id: string;
  firstName?: string;
  lastName?: string;
  email: string;
  username?: string;
  referral_bonus_balance: number;
  referral_count: number;
}

export interface IAffiliateOverviewResponse {
  data: {
    records: {
      affliateCount: number;
      successful_referrals_this_month: number;
      total_successful_referral: number;
      total_pending_referrals: number;
      allreferrals: IAffiliateReferral[];
    };
  };
}

export interface IReferralDetail {
  type: string;
  bookingStatus: string;
  DepartureName?: string;
  ArrivalName?: string;
  transactionStatus: string;
  transactionAmount: number;
  transactionDate: string;
  customer_name: string;
  amountEarned: number;
}

export interface IWithdrawalDetail {
  _id: string;
  bankName: string;
  accountName: string;
  accountNumber: string;
  amount: number;
  status: string;
  verification_status: string;
  verification_code: number;
  user_id: string[];
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface IAffiliateUserResponse {
  success: boolean;
  message: string;
  data: {
    affliate: {
      _id: string;
      firstName: string;
      lastName: string;
      email: string;
      username: string;
      phoneNumber: number;
      role: string;
      verificationId: string;
      verified: boolean;
      reg_completed: boolean;
      referral_code: string;
      referral_bonus_balance: number;
      referral_count: number;
      createdAt: string;
      image?: string;
    };
    affliateWithdrawal: IWithdrawalDetail[];
    referrals: IReferralDetail[];
  };
}

export interface IAffiliateUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  joinedDate: string;
  totalReferrals: number;
  totalEarnings: number;
  withdrawnAmount: number;
  status: string;
}

export interface IWithdrawalRequest {
  withdraw_id: string;
  status: "approve" | "decline";
}

// Get affiliate overview statistics
export const getAffiliateOverview =
  async (): Promise<IAffiliateOverviewResponse> => {
    const res = http.get("/admin/affiliateoverview");
    return (await res).data;
  };

// Get specific affiliate user details
export const getAffiliateUser = async (
  userId: string
): Promise<IAffiliateUserResponse> => {
  const res = http.get(`/admin/affiliate/${userId}`);
  return (await res).data;
};

// Process affiliate withdrawal approval or rejection
export const processWithdrawal = async (
  username: string,
  body: IWithdrawalRequest
) => {
  const res = http.post(`/admin/affiliateapproval/${username}`, body);
  return (await res).data;
};
